import React, { Component } from 'react';
import { array, object } from 'prop-types';

import _ from 'lodash';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Divider from '@material-ui/core/Divider';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import CompanyCard from '../../components/CompanyCard';
import CreateCompanyModal from '../Modals/CreateCompanyModal';

import classes from './DefaultCompanyCard.module.css';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CoreActions from '../../actions/coreActions';
import * as CompanyInfoActions from '../../actions/companyInfoActions';

const BILLING_STATUS = ['Awaiting Confirmation', 'On Hold', 'Ok', 'Delinquent'];

class DefaultCompanyCard extends Component {
    state = {
        menuOpen:  false,
        modalOpen: false
    }

    handleToggleModal = () => {
        this.setState(state => ({
            modalOpen: !state.modalOpen
        }));
    }

    handleCompanySelect = async company => {
        const { defaultCompany, setDefaultCompany } = this.props;

        if (_.get(defaultCompany, 'company.id', '') === company.id) {
            return;
        }

        const defaultCompanyBody = {
            defaultCompany: {}
        };

        defaultCompanyBody.defaultCompany.id = company.id;

        await setDefaultCompany(defaultCompanyBody);

        window.location.reload();
    }

    handleToggleMenu = () => {
        let toggleState = this.state.menuOpen;

        this.setState({menuOpen: !toggleState});
    }

    handleClickAway = () => {
        this.setState({menuOpen: false});
    }

    iconSelect = () => {
        const { defaultCompany } = this.props;

        switch (_.get(defaultCompany, 'company.billingStatus', '')) {
            case 0:
                return '/assets/images/billing-delinquent.svg';
            case 1:
                return '/assets/images/billing-on-hold.svg';
            case 2:
                return '/assets/images/billing-ok.svg';
            case 3:
                return '/assets/images/billing-delinquent.svg';
            default:
                return '';
        }
    }

    populateDefaultCompany = () => {
        const { defaultCompany } = this.props;

        const companyContractorTypes = _.chain(defaultCompany).get('contractorTypes', []).map(type => type.name).value();
        const companyBillingStatus = _.get(defaultCompany, 'company.billingStatus', '');
        const companyAddress = _.get(defaultCompany, 'company.address.formattedAddress', '');
        const companyName = _.get(defaultCompany, 'company.name', null);
        const companyId = _.get(defaultCompany, 'company.id', null);

        let displayedCompanyContractorType = _.isEmpty(companyContractorTypes) ? '' : companyContractorTypes.join(', ');
        let displayedCompanyBillingStatus = _.isEmpty(companyBillingStatus) ? '' : BILLING_STATUS[companyBillingStatus];
        let displayedCompanyEnabledStatus = _.get(defaultCompany, 'company.enabled') ? 'Yes' : 'No';
        let anchorEl;

        if (this.props.companies && this.props.companies.length) {
            return (
                <div className={classes.innerContainer}>
                    {companyId === null && <p>Select a default company.</p>}
                    {companyId !== null &&
                    <div className={classes.companyInfo}>
                        <Table>
                            <TableBody>
                                <TableRow className={classes.companyRow}>
                                    <TableCell className={classes.companyInfoLabel}>Address</TableCell>
                                    <TableCell className={classes.companyInfoData}>{companyAddress}</TableCell>
                                </TableRow>
                                <TableRow className={classes.companyRow}>
                                    <TableCell className={classes.companyInfoLabel}>Contractor Type</TableCell>
                                    <TableCell className={classes.companyInfoData}>{displayedCompanyContractorType}</TableCell>
                                </TableRow>
                                <TableRow className={classes.companyRow}>
                                    <TableCell className={classes.companyInfoLabel}>Billing Status</TableCell>
                                    <TableCell className={classes.companyInfoData}>{displayedCompanyBillingStatus}
                                        <img
                                            className={classes.icon}
                                            src={this.iconSelect()}
                                            alt="billing-status icon"
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.companyRow}>
                                    <TableCell className={classes.companyInfoLabel}>Enabled</TableCell>
                                    <TableCell className={classes.companyInfoData}>{displayedCompanyEnabledStatus}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>}
                    <ClickAwayListener onClickAway={this.handleClickAway}>
                        <React.Fragment>
                            <Button
                                buttonRef={node => {
                                    anchorEl = node;
                                }}
                                color="primary"
                                variant="contained"
                                aria-owns={this.state.menuOpen ? 'company-list' : null}
                                aria-haspopup="true"
                                onClick={this.handleToggleMenu}
                            >
                                <span>{companyName || 'Select Default'}</span>
                                <i className="fas fa-caret-down" />
                            </Button>
                            <Popper
                                open={this.state.menuOpen}
                                anchorEl={anchorEl}
                                transition
                                disablePortal
                                className={classes.companyMenu}
                            >
                                {({ TransitionProps }) => (
                                    <Grow
                                        {...TransitionProps}
                                        id="company-list"
                                    >
                                        <Paper>
                                            <MenuList>
                                                {this.props.companies.map(company => {
                                                    return (
                                                        <MenuItem
                                                            onClick={() => this.handleCompanySelect(company.company)}
                                                            key={company.company.id}
                                                            className={company.company.id === companyId ? classes.selected : ''}
                                                        >
                                                            <span>{company.company.name}</span>
                                                        </MenuItem>
                                                    );
                                                })}
                                                <Divider />
                                                <MenuItem onClick={this.handleToggleModal}> + Create New Company</MenuItem>
                                            </MenuList>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </React.Fragment>
                    </ClickAwayListener>
                </div>
            );
        }

        return (
            <div className={classes.innerContainer}>
                <p>You have not yet created a Company.</p>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleToggleModal}
                >
                    Create Company
                </Button>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CompanyCard
                    title="Default Company"
                    imagePath="/assets/images/appartmentComplexFlat.svg"
                >
                    {this.populateDefaultCompany()}
                </CompanyCard>
                <CreateCompanyModal
                    open={this.state.modalOpen}
                    close={this.handleToggleModal}
                    title="Create Company"
                />
            </React.Fragment>
        );
    }
}

DefaultCompanyCard.defaultProps = {
    companyInfo:     {},
    companies:       [],
    contractorTypes: [],
    defaultCompany:  {}
};

DefaultCompanyCard.propTypes = {
    companyInfo:     object,
    companies:       array,
    contractorTypes: array,
    defaultCompany:  object
};

const mapStateToProps = state => {
    return {
        companies:       state.core.companies,
        companyInfo:     state.companyInfo,
        contractorTypes: state.companyInfo.contractorTypes,
        defaultCompany:  state.core.defaultCompany
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...CoreActions,
    ...CompanyInfoActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultCompanyCard);
